@layer reset, default, limit, role, margin;

@layer reset {
  :host {
    display: block;
    color: var(--gcds-heading-default-text);

    :is(h1, h2, h3, h4, h5, h6) {
      box-sizing: border-box;
      margin: 0;
    }

    slot {
      display: initial;
    }
  }
}

@layer default {
  :host {
    :is(h1, h2, h3, h4, h5, h6) {
      text-wrap: balance;
    }

    h1.gcds-heading {
      font: var(--gcds-heading-h1-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-heading-h1-mobile);
      }

      &:after {
        content: '';
        display: block;
        width: var(--gcds-heading-h1-border-width);
        margin-block-start: var(--gcds-heading-h1-border-margin);
        height: var(--gcds-heading-h1-border-height);
        background-color: var(--gcds-heading-h1-border-background);
      }
    }

    h2.gcds-heading {
      font: var(--gcds-heading-h2-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-heading-h2-mobile);
      }
    }

    h3.gcds-heading {
      font: var(--gcds-heading-h3-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-heading-h3-mobile);
      }
    }

    h4.gcds-heading {
      font: var(--gcds-heading-h4-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-heading-h4-mobile);
      }
    }

    h5.gcds-heading {
      font: var(--gcds-heading-h5-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-heading-h5-mobile);
      }
    }

    h6.gcds-heading {
      font: var(--gcds-heading-h6-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-heading-h6-mobile);
      }
    }
  }
}

@layer limit {
  :host {
    h1.limit {
      max-width: var(--gcds-heading-character-limit-h1);
    }

    h2.limit {
      max-width: var(--gcds-heading-character-limit-h2);
    }

    h3.limit {
      max-width: var(--gcds-heading-character-limit-h3);
    }

    h4.limit {
      max-width: var(--gcds-heading-character-limit-h4);
    }

    h5.limit {
      max-width: var(--gcds-heading-character-limit-h5);
    }

    h6.limit {
      max-width: var(--gcds-heading-character-limit-h6);
    }
  }
}

@layer margin {
  :host {
    :is(h1, h2, h3, h4, h5, h6) {
      /* Margin top */
      &.mt-0 {
        margin-block-start: var(--gcds-heading-spacing-0);
      }

      &.mt-25 {
        margin-block-start: var(--gcds-heading-spacing-25);
      }

      &.mt-50 {
        margin-block-start: var(--gcds-heading-spacing-50);
      }

      &.mt-75 {
        margin-block-start: var(--gcds-heading-spacing-75);
      }

      &.mt-100 {
        margin-block-start: var(--gcds-heading-spacing-100);
      }

      &.mt-125 {
        margin-block-start: var(--gcds-heading-spacing-125);
      }

      &.mt-150 {
        margin-block-start: var(--gcds-heading-spacing-150);
      }

      &.mt-175 {
        margin-block-start: var(--gcds-heading-spacing-175);
      }

      &.mt-200 {
        margin-block-start: var(--gcds-heading-spacing-200);
      }

      &.mt-225 {
        margin-block-start: var(--gcds-heading-spacing-225);
      }

      &.mt-250 {
        margin-block-start: var(--gcds-heading-spacing-250);
      }

      &.mt-300 {
        margin-block-start: var(--gcds-heading-spacing-300);
      }

      &.mt-350 {
        margin-block-start: var(--gcds-heading-spacing-350);
      }

      &.mt-400 {
        margin-block-start: var(--gcds-heading-spacing-400);
      }

      &.mt-450 {
        margin-block-start: var(--gcds-heading-spacing-450);
      }

      &.mt-500 {
        margin-block-start: var(--gcds-heading-spacing-500);
      }

      &.mt-550 {
        margin-block-start: var(--gcds-heading-spacing-550);
      }

      &.mt-600 {
        margin-block-start: var(--gcds-heading-spacing-600);
      }

      &.mt-650 {
        margin-block-start: var(--gcds-heading-spacing-650);
      }

      &.mt-700 {
        margin-block-start: var(--gcds-heading-spacing-700);
      }

      &.mt-750 {
        margin-block-start: var(--gcds-heading-spacing-750);
      }

      &.mt-800 {
        margin-block-start: var(--gcds-heading-spacing-800);
      }

      &.mt-850 {
        margin-block-start: var(--gcds-heading-spacing-850);
      }

      &.mt-900 {
        margin-block-start: var(--gcds-heading-spacing-900);
      }

      &.mt-950 {
        margin-block-start: var(--gcds-heading-spacing-950);
      }

      &.mt-1000 {
        margin-block-start: var(--gcds-heading-spacing-1000);
      }

      &.mt-1050 {
        margin-block-start: var(--gcds-heading-spacing-1050);
      }

      &.mt-1100 {
        margin-block-start: var(--gcds-heading-spacing-1100);
      }

      &.mt-1150 {
        margin-block-start: var(--gcds-heading-spacing-1150);
      }

      &.mt-1200 {
        margin-block-start: var(--gcds-heading-spacing-1200);
      }

      &.mt-1250 {
        margin-block-start: var(--gcds-heading-spacing-1250);
      }

      /* Margin bottom */
      &.mb-0 {
        margin-block-end: var(--gcds-heading-spacing-0);
      }

      &.mb-25 {
        margin-block-end: var(--gcds-heading-spacing-25);
      }

      &.mb-50 {
        margin-block-end: var(--gcds-heading-spacing-50);
      }

      &.mb-75 {
        margin-block-end: var(--gcds-heading-spacing-75);
      }

      &.mb-100 {
        margin-block-end: var(--gcds-heading-spacing-100);
      }

      &.mb-125 {
        margin-block-end: var(--gcds-heading-spacing-125);
      }

      &.mb-150 {
        margin-block-end: var(--gcds-heading-spacing-150);
      }

      &.mb-175 {
        margin-block-end: var(--gcds-heading-spacing-175);
      }

      &.mb-200 {
        margin-block-end: var(--gcds-heading-spacing-200);
      }

      &.mb-225 {
        margin-block-end: var(--gcds-heading-spacing-225);
      }

      &.mb-250 {
        margin-block-end: var(--gcds-heading-spacing-250);
      }

      &.mb-300 {
        margin-block-end: var(--gcds-heading-spacing-300);
      }

      &.mb-350 {
        margin-block-end: var(--gcds-heading-spacing-350);
      }

      &.mb-400 {
        margin-block-end: var(--gcds-heading-spacing-400);
      }

      &.mb-450 {
        margin-block-end: var(--gcds-heading-spacing-450);
      }

      &.mb-500 {
        margin-block-end: var(--gcds-heading-spacing-500);
      }

      &.mb-550 {
        margin-block-end: var(--gcds-heading-spacing-550);
      }

      &.mb-600 {
        margin-block-end: var(--gcds-heading-spacing-600);
      }

      &.mb-650 {
        margin-block-end: var(--gcds-heading-spacing-650);
      }

      &.mb-700 {
        margin-block-end: var(--gcds-heading-spacing-700);
      }

      &.mb-750 {
        margin-block-end: var(--gcds-heading-spacing-750);
      }

      &.mb-800 {
        margin-block-end: var(--gcds-heading-spacing-800);
      }

      &.mb-850 {
        margin-block-end: var(--gcds-heading-spacing-850);
      }

      &.mb-900 {
        margin-block-end: var(--gcds-heading-spacing-900);
      }

      &.mb-950 {
        margin-block-end: var(--gcds-heading-spacing-950);
      }

      &.mb-1000 {
        margin-block-end: var(--gcds-heading-spacing-1000);
      }

      &.mb-1050 {
        margin-block-end: var(--gcds-heading-spacing-1050);
      }

      &.mb-1100 {
        margin-block-end: var(--gcds-heading-spacing-1100);
      }

      &.mb-1150 {
        margin-block-end: var(--gcds-heading-spacing-1150);
      }

      &.mb-1200 {
        margin-block-end: var(--gcds-heading-spacing-1200);
      }

      &.mb-1250 {
        margin-block-end: var(--gcds-heading-spacing-1250);
      }
    }
  }
}

@layer role {
  :host .gcds-heading {
    &.role-primary {
      color: var(--gcds-heading-role-primary);
    }

    &.role-secondary {
      color: var(--gcds-heading-role-secondary);
    }

    &.role-light {
      color: var(--gcds-heading-role-light);
    }
  }
}
